import React, { useContext, useEffect, useRef, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ThemeContext } from 'styled-components';

import YatLoader from '@pkg/components/Sections/Profile/Loader';
import { DepAssetHandler } from '@pkg/components/deprecated';

import { AssetWrapper, NFTWrapper } from './styles';

interface Props {
    className?: string;
    image?: string;
    video?: string;
    fallback?: string;
    dragging?: boolean;
    onLoaded?: () => void;
}

const YatNFT = ({ className, image, video, dragging, fallback, onLoaded }: Props) => {
    const theme = useContext(ThemeContext);
    const { ref, inView } = useInView({ threshold: 0, triggerOnce: true });
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (!videoRef.current) return;

        if (dragging) videoRef.current.pause();
        else videoRef.current.play();
    }, [dragging]);

    const handleLoaded = () => {
        setLoaded(true);
        if (onLoaded) onLoaded();
    };

    const handleError = () => {
        setError(true);
    };

    return (
        <NFTWrapper
            ref={ref}
            className={className}
            $loaded={loaded && !error}
            initial="initial"
            animate={loaded && 'loaded'}
        >
            <YatLoader show={!loaded} />

            <AnimatePresence>
                {inView && (
                    <AssetWrapper
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: theme.transitions.speeds.normal }}
                    >
                        <DepAssetHandler
                            fallback={fallback}
                            videoRef={videoRef}
                            videoUrl={video}
                            imageUrl={image}
                            onError={handleError}
                            onLoad={handleLoaded}
                            controls
                        />
                    </AssetWrapper>
                )}
            </AnimatePresence>
        </NFTWrapper>
    );
};

export default YatNFT;
